import React from "react";

import { bemClassName } from "../../utils/bemClassName";
import { useSearchResults } from "../../context/DataContext";
import PaginationControl from "./PaginationControl";
import PaginationItem, { ItemTypeValues } from "./PaginationItem";

export type PaginationProps = {
    itemType?: ItemTypeValues;
    label?: string;
    maxPages: number;
    stepLabel?: string;
    disabled?: boolean;
};

export const Pagination = ({
    itemType = "link",
    label = "Pagination",
    stepLabel = "page",
    disabled = false,
}: PaginationProps) => {
    if (disabled) return null;

    const { pagination } = useSearchResults();
    const { controls, items } = pagination;
    const maybeControlPrevious = controls?.previous ? (
        <PaginationControl
            direction="previous"
            itemType={controls.previous.itemType || itemType}
            stepLabel={controls.previous.stepLabel || stepLabel}
        />
    ) : null;
    const maybeControlNext = controls?.next ? (
        <PaginationControl
            direction="next"
            itemType={controls.next.itemType || itemType}
            stepLabel={controls.next.stepLabel || stepLabel}
        />
    ) : null;
    const maybeControls = controls ? (
        <div
            className={bemClassName(
                "ripple-news-listing",
                "pagination-controls"
            )}
        >
            {maybeControlPrevious}
            {maybeControlNext}
        </div>
    ) : null;
    const maybePagination = items.length ? (
        <nav
            className={bemClassName("ripple-news-listing", "pagination")}
            aria-label={label}
        >
            <ul
                className={bemClassName(
                    "ripple-news-listing",
                    "pagination-list"
                )}
            >
                {items.map((item) => {
                    const {
                        itemType: paginationItemType,
                        pageNumber: paginationItemPageNumber,
                        stepLabel: paginationItemStepLabel,
                    } = item;
                    const itemProps = {
                        ...item,
                        itemType: paginationItemType
                            ? paginationItemType
                            : itemType,
                        stepLabel: paginationItemStepLabel
                            ? paginationItemStepLabel
                            : stepLabel,
                    };
                    return (
                        <PaginationItem
                            {...itemProps}
                            key={`pagination-item-${paginationItemPageNumber}`}
                        />
                    );
                })}
            </ul>
            {maybeControls}
        </nav>
    ) : null;

    return maybePagination;
};

export default Pagination;
